import { render, staticRenderFns } from "./BancoDeCartasICVisualizar.vue?vue&type=template&id=4e1c8b18"
import script from "./BancoDeCartasICVisualizar.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasICVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports